export default __webpack_public_path__ + "static/media/finalising-medication.7b83da01.svg";